<template>
  <div class="headerBox">
    <div class="mainBox">
      <!-- logo -->
      <div class="logo" @click="changeMenu(0)">
        <img src="https://images.zhibo.tv/2021/0730/logo.png" alt="" />
      </div>
      <!-- 导航栏 -->
      <div class="menuList">
        <div
          class="menuItem"
          :class="{ activeItem: index === menuIndex }"
          v-for="(item, index) in menuList"
          :key="index"
          @click="changeMenu(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 右上角--登录按钮或者是用户头像 -->
      <div class="rightTopBox">
        <div class="searchBox" :class="{ hasBorder: hasBorder }">
          <input
            type="text"
            @focus="handleFocus(true)"
            @blur="handleFocus(false)"
            placeholder="台球"
            v-model="key"
            @keyup.enter="gotoSearch"
            :class="{ blurInput: !hasBorder }"
          />
          <div class="icon_search" @click="gotoSearch">
            <img
              src="https://images.zhibo.tv/2020/0601/icon_search.svg"
              alt=""
            />
          </div>
        </div>
        <div
          class="loginBox"
          @mouseenter="handleHover(true)"
          @mouseleave="handleHover(false)"
        >
          <!-- 已登录右上角展示用户头像 -->
          <div class="userHead" v-if="isLogin">
            <img class="img" :src="userHeadImg" alt="" />
            <!-- 悬浮态用户信息 -->
            <div class="userInfoBox">
              <div class="topInfo">
                <!-- 头像 -->
                <div class="userHeadImg">
                  <img :src="userHeadImg" alt="" />
                </div>
                <div class="userName">{{ loginInfo.userName }}</div>
                <div class="levelIcon">
                  <img
                    :src="
                      `https://images.zhibo.tv/pc/rich/rich${loginInfo.roomLevel}.png`
                    "
                    alt=""
                  />
                </div>
              </div>
              <div class="centerInfo">
                <div class="levelBox">
                  <div class="levelTop">
                    <div class="levelImg">
                      <img
                        :src="
                          `https://images.zhibo.tv/pc/rich/rich${loginInfo.roomLevel}.png`
                        "
                        alt=""
                      />
                    </div>
                    <div class="levelProgress">
                      <div
                        class="finshedProgress"
                        :style="{
                          width:
                            (loginInfo.userRichLevel.finished /
                              loginInfo.userRichLevel.total) *
                              100 +
                            '%'
                        }"
                      ></div>
                    </div>
                    <div class="levelImg">
                      <img
                        :src="
                          `https://images.zhibo.tv/pc/rich-black/rich${loginInfo.userRichLevel.nextLevel}.png`
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="levelBottom">
                    再消费
                    <span>{{
                      loginInfo.userRichLevel.total -
                        loginInfo.userRichLevel.finished
                    }}</span>
                    播币 升级为
                  </div>
                </div>
                <div class="userHandle">
                  <div class="personCenter" @click="gotoPersonalCenter">
                    个人中心
                  </div>
                  <div class="exitLogin" @click="exitLogin">退出</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 未登录展示登录按钮 -->
          <div class="loginBtn" id="btn_login" v-else @click="gotoLogin">
            登录
          </div>
        </div>
      </div>
    </div>
    <!-- PC登录弹窗 -->
    <pclogin v-if="loginDialogIsShow"></pclogin>
    <!-- PC绑定弹窗 -->
    <pcbind v-if="isThirdNew == 1"></pcbind>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      // 导航列表
      menuList: [
        { name: '首页', path: 'www.zhibo.tv', sign: '/' },
        {
          name: '滚动',
          path: 'v.zhibo.tv/dong-tai/toutiao-index',
          sign: '/dong-tai/toutiao-index'
        },
        // {
        //   name: '世界杯',
        //   path: 'www.zhibo.tv/zt/football/',
        //   sign: '/zt/worldCup/'
        // },
      // {
      //   name: '亚运会',
      //   path: 'www.zhibo.tv/zt/theAsianGames',
      //   sign: '/zt/theAsianGames/'
      // },
        // { name: '主播', path: 'www.zhibo.tv/live/', sign: '/live/' },
        // {
        //   name: '北京冬残奥',
        //   path: 'www.zhibo.tv/zt/olympic2022/',
        //   sign: '/zt/olympic2022/'
        // },
         // { name: '视频', path: 'www.zhibo.tv/vdpage/', sign: '/vdpage/' },
        // {
        //   name: '赛程',
        //   path: 'www.zhibo.tv/raceChannel/',
        //   sign: '/raceChannel/'
        // },
        
        { name: '下载', path: 'www.zhibo.tv/download/', sign: '/download/' },
        { name: '商城', path: 'www.zhibo.tv/newshop/', sign: '/newshop/' },
        { name: '会员', path: 'www.zhibo.tv/member/', sign: '/member/' },
        // { name: '游戏', path: 'game.zhibo.tv/', sign: '/game/' }
      ],
      // 导航选中index
      menuIndex: -1,
      // 是否展示登录弹窗
      loginDialogIsShow: false,
      // 是否登录
      isLogin: false,
      // 登录成功后用户信息
      loginInfo: '',
      // 用户头像
      userHeadImg: '',
      // 悬浮态用户信息是否展示
      userInfoBoxIsShow: false,
      // 搜索关键词
      key: '',
      // 搜索框边框是否是红色
      hasBorder: false,
      // 是否展示三方新用户绑定弹窗
      isThirdNew: '',
      // 父页面url
      parentUrl: '',
      // 路径pathname
      parentPathname: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    this.handleMenuActive()
    // sessionStorage.setItem('menuIndex', this.menuIndex)
    // 是否是三方新用户
    this.isThirdNew = this.$cookies.get('isThirdNew')
    console.log(this.isThirdNew)
    if (this.isThirdNew == 1) {
      setTimeout(() => {
        console.log('通知iframe是三方新用户')
        window.parent.postMessage({ command: 'loginIsShow' }, '*')
      }, 500)
    }
    this.getUserInfo()
    window.addEventListener('message', (event) => {
      console.log('收到', event)
      if (event.data.command == 'reload') {
        window.location.reload()
      }
      if (event.data.command == 'getMenuIndex') {
        this.menuIndex = event.data.menuIndex
          ? Number(event.data.menuIndex)
          : -1
        console.log('导航index', this.menuIndex)
      }
      if (event.data.command == 'parentUrl') {
        console.log('收到父页面url', event)
        this.parentUrl = event.data.url
        this.parentPathname = event.data.pathname
        // this.handleMenuActive()
        this.$cookies.set('login_origin', event.data.url, '1d','','zhibo.tv')
        if (this.parentPathname == '/') {
          this.menuIndex = 0
        }
      }
    })
  },
  mounted() {},
  methods: {
    // 点击导航菜单
    changeMenu(index) {
      this.menuIndex = index
      // sessionStorage.setItem('menuIndex', index)
      let url = `https://${process.env.VUE_APP_BASE}${this.menuList[index].path}?menuIndex=${index}`
      console.log('通知处理导航高亮', url)
      window.parent.postMessage({ command: 'handleMenu', url, index }, '*')
      // window.open(url)
    },
    // 处理导航高亮
    handleMenuActive() {
      if (window.location.pathname == '/') {
        this.menuIndex = 0
      }
    },
    // 登录
    gotoLogin() {
      // 处理iframe跨域,通知父页面,修改iframe的高度
      window.parent.postMessage({ command: 'loginIsShow' }, '*')
      // 点击登录时，
      this.loginDialogIsShow = true
    },
    // 鼠标移入用户头像
    handleHover(visible) {
      console.log('鼠标移入用户头像发送了', visible)
      // 处理iframe跨域,通知父页面,修改iframe的高度
      window.parent.postMessage(
        { command: 'userInfoIsShow', visible: visible },
        '*'
      )
      // this.userInfoBoxIsShow = visible
    },
    // 获取用户信息
    async getUserInfo() {
      axios.defaults.withCredentials = true
      let res = await this.$api.getUserInfo()
      console.log(res)
      if (res.data.status == 200) {
        this.loginInfo = res.data.data
        this.userHeadImg =
          this.loginInfo.userHeadImg.indexOf('http') > -1
            ? this.loginInfo.userHeadImg
            : `https://${process.env.VUE_APP_BASE}file.zhibo.tv${this.loginInfo.userHeadImg}`
        this.isLogin = true
        sessionStorage.setItem(
          'userToken',
          JSON.stringify(res.data.data.userToken)
        )
        sessionStorage.setItem(
          'userMobile',
          JSON.stringify(res.data.data.userMobile)
        )
        sessionStorage.setItem(
          'userPoints',
          JSON.stringify(res.data.data.userPoints)
        )
      } else {
        sessionStorage.setItem('userToken', JSON.stringify(''))
        sessionStorage.setItem('userPoints', JSON.stringify(''))
        sessionStorage.setItem('userMobile', JSON.stringify(''))
        console.log('没取到')
      }
    },
    // 跳转个人中心
    gotoPersonalCenter() {
      // window.location.href = `https://${process.env.VUE_APP_BASE}www.zhibo.tv/home/`
      window.open(`https://${process.env.VUE_APP_BASE}www.zhibo.tv/home/`)
    },
    // 处理搜索聚焦失焦状态
    handleFocus(visible) {
      this.hasBorder = visible
    },
    // 跳转登录
    gotoSearch() {
      let key = this.key.length ? this.key : '台球'
      console.log('搜索关键词', this.key)
      let url = `https://${process.env.VUE_APP_BASE}www.zhibo.tv/newsearch?keyword=${key}`
      window.open(url)
    },
    // 退出登录
    async exitLogin() {
      let res = await this.$api.loginOutfromPC()
      console.log(res)
      if (res.data.status == 200) {
        // 发送通知,已退出登录
        window.parent.postMessage({ command: 'loginout' }, '*')
        window.parent.postMessage({ command: 'reload' }, '*')
        console.log('退出登录成功')
        sessionStorage.removeItem('userToken')
        sessionStorage.removeItem('userPoints')
        sessionStorage.removeItem('userIsHoster')
        sessionStorage.removeItem('userMobile')

        window.location.reload()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.headerBox {
  width: 100%;
  height: 72px;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(179, 179, 179, 0.13);
  position: relative;
  .mainBox {
    width: 1200px;
    height: 72px;
    margin: 0 auto;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .logo {
      width: 180px;
      height: 49px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      // margin-right: 24px;
      img {
        display: block;
        width: 174px;
        height: 45px;
      }
    }
    // 导航
    .menuList {
      width: 720px;
      display: flex;
      // justify-content: center;
      align-items: center;
      .menuItem {
        width: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        flex-shrink: 0;

        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        white-space: nowrap;
        &:hover {
          color: #e9001d;
        }
      }
      .activeItem {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #e9001d;
      }
    }
    // 右上角
    .rightTopBox {
      display: flex;
      align-items: center;
      .searchBox {
        width: 160px;
        height: 36px;
        margin-right: 10px;
        border-radius: 18px;
        overflow: hidden;
        box-sizing: border-box;
        background: #f8f8f8;
        padding: 7px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #e5e5e5;
        &:hover {
          // box-sizing: border-box;
          border: 1px solid #e9001d;
        }

        input {
          // flex-shrink: 0;
          display: block;
          width: 100%;
          height: 100%;
          background: #f8f8f8;

          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333;
        }
        input::placeholder {
          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #999999;
          // line-height: 27px;
        }
        .blurInput {
          color: #999999;
        }
        .icon_search {
          width: 13px;
          height: 13px;
          margin-left: 5px;
          cursor: pointer;
          // flex-shrink: 0;
          img {
            display: block;
            width: 13px;
            height: 13px;
          }
        }
      }
      .hasBorder {
        border: 1px solid #e9001d;
      }
      .loginBox {
        width: 88px;
        height: 172px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .loginBtn {
          width: 88px;
          height: 36px;
          background: linear-gradient(135deg, #ff4a4a 0%, #e9001d 100%);
          border-radius: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 36px;
          &:hover {
            opacity: 0.9;
          }
        }
        .userHead {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          // overflow: hidden;
          cursor: pointer;
          border: 1px solid #e5e5e5;
          position: relative;
          .img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
          }

          .userInfoBox {
            position: absolute;
            top: 62px;
            right: 0;
            width: 300px;
            height: 172px;
            background: #ffffff;
            box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.13);
            border-radius: 4px;
            visibility: hidden;
            overflow: hidden;
            .topInfo {
              height: 60px;
              background: linear-gradient(157deg, #292929 0%, #9f041b 100%);
              display: flex;
              align-items: center;
              .userHeadImg {
                width: 34px;
                height: 34px;
                margin: 0 10px;
                border-radius: 50%;
                overflow: hidden;
                border: 1px solid #e5e5e5;
                img {
                  display: block;
                  width: 34px;
                  height: 34px;
                }
              }
              .userName {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
              }
              .levelIcon {
                width: 45px;
                height: 19px;
                margin-left: 6px;
                img {
                  width: 45px;
                  height: 19px;
                  object-fit: cover;
                }
              }
            }
            .centerInfo {
              height: 112px;
              box-sizing: border-box;
              padding: 10px 10px 0 10px;
              .levelBox {
                height: 48px;
                // background: #f8f8f8;
                border-radius: 4px;
                margin-bottom: 13px;
                .levelTop {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 10px 5px 0 5px;
                  .levelImg {
                    width: 45px;
                    height: 20px;
                    img {
                      display: block;
                      // object-fit: cover;
                      width: 45px;
                      height: 20px;
                    }
                  }
                  .levelProgress {
                    width: 161px;
                    height: 5px;
                    background: rgba(67, 33, 38, 0.1);
                    border-radius: 3px;
                    position: relative;
                    overflow: hidden;
                    .finshedProgress {
                      max-width: 100%;
                      height: 5px;
                      background: #591a23;
                      border-radius: 3px;
                      position: absolute;
                      left: 0;
                    }
                  }
                }
                .levelBottom {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #aeaeae;
                  text-align: center;
                  span {
                    color: #f5a623;
                  }
                }
              }
              .userHandle {
                border-top: 1px solid #e5e5e5;
                height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9c9c9c;
                .personCenter {
                  margin-left: 5px;
                }
                .exitLogin {
                  margin-right: 5px;
                }
              }
            }
          }
        }
        &:hover .userInfoBox {
          visibility: visible;
        }
      }
    }
  }
  .loginDialog {
    position: fixed;
    top: 0;
    left: 0;
  }
}
</style>
